import React from 'react';
import Typography from '@mui/material/Typography';

const FormSection = ({ title, children }) => (
  <div className="gdl-section-card">
    <Typography variant="h6" className="gdl-section-title">
      {title}
    </Typography>
    <div className="gdl-section-grid">
      {children}
    </div>
  </div>
);

export default FormSection;
